import { hmapPathParamConfig, hmapPathParamRegex } from "@ngmodules/hmap/hmap.routes";
export const CustomSourcesRoutes = [
    {
        "url": "/:view?tab",
        "name": "appLayout.harriSH.settings.brandSection",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["custom_sources"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/custom-sources/custom-sources.downgrade.module");
                }
            }
        ]
    },
    {
        "url": `/settings/${hmapPathParamRegex}?activeTab&subTab`,
        "name": "appLayout.harriSH.access-portal.settings.main",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig,
        },
        "component": "hmapSettingsPage",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["custom_sources"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/custom-sources/custom-sources.downgrade.module");
                }
            }
        ]
    },
];
//# sourceMappingURL=custom-sources.routes.js.map